<div class="row">
    <ng-container *ngFor="let request of requests">
        <div class="col-md-6 col-lg-4 col-xxl-4 col-xxxl-3 animated-col">
            <div class="request-card ccc ccc-hover" role="button" (click)="viewDetails(request.requestId)">
                <div HJSuppress class="card-title text-center">
                    <dynamic-field [props]="props?.DictionaryRequestTypeName" [canBeEmpty]="true">
                        {{request.dictionaryRequestTypeName}}
                    </dynamic-field>
                </div>
                <div class="card-content">
                    <div HJSuppress class="plate-number">
                        <dynamic-field [props]="props?.PlateNumber" [canBeEmpty]="true">
                            {{request.plateNumber}}
                        </dynamic-field>
                    </div>
                    <div HJSuppress class="delegate-name text-center">
                        <dynamic-field [props]="props?.DelegateName" [canBeEmpty]="true">
                            {{request.delegateName}}
                        </dynamic-field>
                    </div>
                    <ng-container *ngIf="request.dictionaryRequestTypeCode === DictionaryAssetDocumentRequestTypes.OTHER">
                        <span class="date-label">{{'requests.cards.dateOfRequest' | translate}}</span>
                        <dynamic-field [props]="props?.CreatedOn" [canBeEmpty]="true">
                            <span class="date-value" HJSuppress>{{request.createdOn | localizedDate}}</span>
                        </dynamic-field>
                    </ng-container>
                    <ng-container *ngIf="request.dictionaryRequestTypeCode === DictionaryAssetDocumentRequestTypes.DRIVING_ABROAD">
                        <div class="transit-countries">
                            <dynamic-field [props]="props?.NumberOfTransitedCountries" [canBeEmpty]="true">
                                <span class="countries-count" HJSuppress>
                                    {{request.numberOfTransitedCountries}}
                                </span>
                                <span> {{'requests.cards.numberOfTransitedCountries' | translate}}</span>
                            </dynamic-field>
                        </div>
                        <dynamic-field [props]="props?.HasGreenInsurance" [canBeEmpty]="true">
                            <div class="card-details-label" *ngIf="request.hasGreenInsurance">
                                {{'requests.cards.hasGreenInsurance' | translate}}
                            </div>
                        </dynamic-field>
                    </ng-container>
                </div>
                <ng-container *ngIf="request.dictionaryRequestTypeCode === DictionaryAssetDocumentRequestTypes.VIGNETTE">
                    <div class="request-dates">
                        <div class="card-item-date">
                            <dynamic-field [props]="props?.EventDate" [canBeEmpty]="true">
                                <div class="d-flex flex-column">
                                    <span class="date-label">
                                        {{'requests.wizard.questions.ValabilityStartingDate' | translate}}
                                    </span>
                                    <span HJSuppress class="date-value">
                                        {{request.eventDate | localizedDate}}
                                    </span>
                                </div>
                            </dynamic-field>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="request.dictionaryRequestTypeCode === DictionaryAssetDocumentRequestTypes.DRIVING_ABROAD">
                    <div class="request-dates">
                        <div class="date-label">
                            {{'common.period' | translate}}
                        </div>
                        <div class="d-flex align-items-center justify-content-center gap-3">
                            <dynamic-field [props]="props?.TransitFromDate" [canBeEmpty]="true">
                                <div HJSuppress class="date-value card-item-startdate">
                                    {{request.transitFromDate | localizedDate}}
                                </div>
                            </dynamic-field>
                            <i class="app-icon icon icon-arrow-right icon-lg"></i>
                            <dynamic-field [props]="props?.TransitToDate" [canBeEmpty]="true">
                                <div HJSuppress class="date-value card-item-enddate">
                                    {{request.transitToDate | localizedDate}}
                                </div>
                            </dynamic-field>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="request.dictionaryRequestTypeCode === DictionaryAssetDocumentRequestTypes.DAMAGE_DELEGACY">
                    <div class="request-dates">
                        <div class="card-item-date">
                            <dynamic-field [props]="props?.EventDate" [canBeEmpty]="true">
                                <div class="d-flex flex-column">
                                    <span class="date-label">
                                        {{'requests.cards.eventDate' | translate}}
                                    </span>
                                    <span HJSuppress class="date-value">
                                        {{request.eventDate | localizedDate}}
                                    </span>
                                </div>
                            </dynamic-field>
                        </div>
                    </div>
                </ng-container>
                <div class="status-box mt-3">
                    <dynamic-field [props]="props?.DictionaryRequestStatus" [canBeEmpty]="true">
                        <div class="status-content">
                            <div class="status-dot" 
                                [ngClass]="request.dictionaryRequestStatus?.code===dictionaryRequestStatus.POSTED ? 'status-posted':
                                    request.dictionaryRequestStatus?.code===dictionaryRequestStatus.IN_PROGRESS ? 'status-in-progress':
                                    request.dictionaryRequestStatus?.code===dictionaryRequestStatus.RESOLVED ? 'status-resolved': 
                                    request.dictionaryRequestStatus?.code===dictionaryRequestStatus.CLOSED ? 'status-closed': ''">
                            </div>
                            <div class="status-value">{{request?.dictionaryRequestStatus?.value}}</div>
                        </div>
                    </dynamic-field>   
                </div>
            </div>
        </div>
    </ng-container>
</div>
